import { action, makeObservable, observable } from "mobx";
import { APIBlobResponse } from "../models/NetworkResponse";
import VouchersAPI from "../api/VouchersAPI";
import { PullVoucherRequest, Voucher } from "../models/Vouchers/Voucher";
import { VoucherAPIFilters } from "../models/Vouchers/VoucherFilters";
import VoucherEmailerAPI from "../api/EmailerAPI";

export class VoucherStore {
  voucherAPI: VouchersAPI;
  voucherEmailerAPI: VoucherEmailerAPI;
  vouchers: Voucher[];
  pullVouchersRequests: PullVoucherRequest[];
  limit: number;
  total_count: number;
  total_pages: number;

  requestLimit: number;
  requestTotal_count: number;
  requestTotal_pages: number;

  constructor() {
    this.voucherAPI = new VouchersAPI();
    this.voucherEmailerAPI = new VoucherEmailerAPI();
    this.limit = 0;
    this.total_count = 0;
    this.total_pages = 0;
    this.vouchers = [];
    this.pullVouchersRequests = [];
    this.requestLimit = 0;
    this.requestTotal_count = 0;
    this.requestTotal_pages = 0;

    makeObservable(this, {
      vouchers: observable,
      limit: observable,
      total_count: observable,
      total_pages: observable,
      getVouchers: action,
      syncAllBrands: action,
      pullVouchersRequests: observable,
      getPullVouchersRequests: action,
    });
  }

  getVouchers = async (filters: VoucherAPIFilters) => {
    try {
      const response = await this.voucherAPI.getVouchers(filters);
      this.vouchers = response.list;
      this.limit = response.limit;
      this.total_count = response.total_count;
      this.total_pages = response.total_pages;
    } catch (error: any) {
      throw error;
    }
  };

  downloadVouchers = async (
    filters: VoucherAPIFilters,
  ): Promise<APIBlobResponse> => {
    try {
      const response: APIBlobResponse =
        await this.voucherAPI.downloadVouchers(filters);
      return response;
    } catch (error: any) {
      throw error;
    }
  };

  syncAllBrands = async () => {
    try {
      const response = await this.voucherAPI.syncAllBrands();
      return response;
    } catch (error: any) {
      throw error;
    }
  };

  getPullVouchersRequests = async () => {
    try {
      const response = await this.voucherAPI.getPullVouchersRequests();
      this.pullVouchersRequests = response.list;
      this.requestLimit = response.limit;
      this.requestTotal_pages = response.total_pages;
      this.requestTotal_count = response.total_count;
    } catch (error: any) {
      throw error;
    }
  };
}
